document.addEventListener('DOMContentLoaded', function(){
  var header = document.querySelector('.header-wrapper');
  var hero   = document.getElementById('shopify-section-hero');
  if (!header || !hero) return;

  // When we've scrolled past the bottom of the hero...
  var triggerY = hero.offsetTop + hero.offsetHeight - header.offsetHeight;

  window.addEventListener('scroll', function(){
    if (window.scrollY > triggerY) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });
});
